import AuthenticationError from './authentication_error'

export default class ProviderAlreadyLinkedError extends AuthenticationError<'auth/provider-already-linked'> {
  constructor (message: string, originalError: any) {
    super(message, originalError, 'auth/provider-already-linked')
  }
}
